export const colors = {
  ink: "#06185f",
  muted: "#4c5d86",
  blue: "#0059f6",
  line: "#d9e3f4",
  green: "#27b45b",
  amber: "#f6b725",
};

export const statusMeta = {
  EN_ESPERA: { label: "En espera", color: colors.amber, bg: "rgba(246,183,37,0.16)" },
  ENTREGADO: { label: "Entregado", color: colors.green, bg: "rgba(39,180,91,0.14)" },
};

export const paymentLabels = {
  CONTADO: "Contado",
  FINANCIADO: "Financiado",
  FINANCIACION: "Financiación",
  ENTREGA: "Entrega",
  MIXTO: "Mixto",
};

export const paymentOptionLabels = {
  CONTADO: "Contado",
  FINANCIACION: "Financiación",
  ENTREGA: "Entrega",
};

export function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatMoney(value, currency = "ARS") {
  if (value === null || value === undefined || value === "") return "";
  const number = Number(value);
  if (!Number.isFinite(number)) return String(value);
  return `${currency || ""} ${number.toLocaleString("es-AR", { maximumFractionDigits: 0 })}`.trim();
}

export function toNumberOrNull(value) {
  const raw = String(value ?? "").trim().replace(/\./g, "").replace(/,/g, ".");
  if (!raw) return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function getVentaSnapshot(item) {
  const venta = item?.venta || {};
  const formasPago = Array.isArray(venta.formas_pago) && venta.formas_pago.length
    ? venta.formas_pago
    : venta.entrega_usado && venta.forma_pago === "TOMA"
      ? ["ENTREGA"]
      : venta.forma_pago === "FINANCIADO"
        ? ["FINANCIACION"]
        : venta.forma_pago === "MIXTO"
          ? ["CONTADO", "FINANCIACION"]
          : [venta.forma_pago || "CONTADO"].filter(Boolean);
  return {
    estado_vehiculo: venta.estado_vehiculo || "NUEVO",
    marca: venta.marca || "",
    modelo: venta.modelo || "",
    version: venta.version || "",
    color: venta.color || "",
    kilometraje: venta.kilometraje || "",
    precio_venta: venta.precio_venta ?? "",
    moneda_venta: venta.moneda_venta || "ARS",
    forma_pago: venta.forma_pago || "CONTADO",
    formas_pago: formasPago,
    monto_efectivo: venta.monto_efectivo ?? "",
    moneda_pago: venta.moneda_pago || "ARS",
    moneda_contado: venta.moneda_contado || venta.moneda_pago || "ARS",
    tipo_cambio_contado: venta.tipo_cambio_contado ?? "",
    monto_financiado: venta.monto_financiado ?? "",
    tipo_financiacion: venta.tipo_financiacion || "",
    financiacion_cuotas: venta.financiacion_cuotas ?? "",
    cuota_aproximada: venta.cuota_aproximada ?? "",
    moneda_financiacion: venta.moneda_financiacion || "ARS",
    tipo_cambio_financiacion: venta.tipo_cambio_financiacion ?? "",
    entrega_usado: Boolean(venta.entrega_usado || formasPago.includes("ENTREGA")),
    usado_marca: venta.usado_marca || "",
    usado_modelo_version: venta.usado_modelo_version || "",
    usado_anio: venta.usado_anio || "",
    usado_kilometraje: venta.usado_kilometraje || "",
    usado_valor_toma: venta.usado_valor_toma ?? "",
    estado_postventa: venta.estado_postventa || item?.estado_postventa || "EN_ESPERA",
  };
}

export function getClienteSnapshot(item) {
  const cliente = item?.cliente || {};
  return {
    id: cliente.id || item?.cliente_id,
    nombre: cliente.nombre || item?.cliente_nombre || "",
    telefono: cliente.telefono || item?.cliente_telefono || "",
    email: cliente.email || item?.cliente_email || "",
    obtenido_de: cliente.obtenido_de || item?.cliente_obtenido_de || "",
    observacion: cliente.observacion || "",
    fecha_nacimiento: cliente.fecha_nacimiento || "",
    direccion: cliente.direccion || "",
    localidad: cliente.localidad || "",
    codigo_postal: cliente.codigo_postal || "",
    dni: cliente.dni || "",
    cuit_cuil: cliente.cuit_cuil || "",
    estado_civil: cliente.estado_civil || "",
    conyuge_nombre: cliente.conyuge_nombre || "",
    conyuge_dni: cliente.conyuge_dni || "",
    conyuge_fecha_nacimiento: cliente.conyuge_fecha_nacimiento || "",
  };
}
